class PageActivate {
	constructor(props) {
		console.log('PageActivate::constructor(%o)', props);
		let _that = this;
		this.return_to = null;
		_that = Object.assign(this, props);

		_that.form = document.querySelector('#form_activate');
		_that.form_submit = _that.form.querySelector('[type="submit"]');
		_that.form_spinner = _that.form.querySelector('.glyphicon.glyphicon-ajax');
		_that.form_response_message = _that.form.querySelector('#response_message');
		_that.form_activation_code = _that.form.querySelector('[name="activation_code"]');
		_that.form_activation_code.readOnly = false;

		if (_that.recaptcha) {
			_that.recaptcha.ready(() => {
				_that.recaptcha.render('recaptcha', {
					'sitekey': _that.recaptcha_site_key,
					'size': 'invisible',
					'callback': (token) => {
						_that.doAjax()
							.then(response => {
								_that.validateActivationCodeSuccess(response);
							})
							.catch(reason => {
								_that.validateActivationCodeReset(true);
							});
					},
					'expired-callback': (a, b, c) => {
						console.log('expired-callback()');
						_that.recaptcha.reset();
					},
					'error-callback': (a, b, c) => {
						console.log('error-callback(%o, %o, %o)', a, b, c);
					},
				});
			});
		}

		if (typeof _that.tooltip_image_url !== 'undefined') {
			const img = document.createElement('img');
			img.src = _that.tooltip_image_url;
			img.addEventListener('load', () => {
				img.remove();
			});
		}

		$('[data-toggle="popover-image"]').popover({html: true});

		_that.form_activation_code.addEventListener('input', (e) => {
			_that.form_submit.disabled = e.target.value === '';
		});

		_that.form.addEventListener('submit', (e) => {
			_that.form_submit.disabled = true;
			_that.form_activation_code.readOnly = true;
			_that.form_spinner.classList.remove('hidden');
			_that.form_response_message.classList.add('hidden');

			if (_that.form.getAttribute('action') === url('/process_activate')) {
				e.preventDefault();

				if (_that.recaptcha !== null) {
					_that.recaptcha.execute();
				} else {
					_that.doAjax()
						.then(response => {
							_that.validateActivationCodeSuccess(response);
						})
						.catch(reason => {
							_that.validateActivationCodeReset(true);
						})
					;
				}

				return false;
			}
		});
	}

	validateActivationCodeSuccess(response) {
		console.log('PageActivate::validateActivationCodeSuccess(%o)', response);
		let _that = this;

		if (response.status) {
			if (response.mobile_sim !== null && _that.return_to === '/account/checkout') {
				let products = _that.form.querySelectorAll('[name^=product]');
				products.forEach(el => {
					el.remove();
				});

				const product_mobile_sim_quantity = document.createElement('input');
				product_mobile_sim_quantity.type = 'hidden';
				product_mobile_sim_quantity.name = 'products[0][quantity]';
				product_mobile_sim_quantity.value = '1';
				_that.form.appendChild(product_mobile_sim_quantity);

				const product_mobile_sim_id = document.createElement('input');
				product_mobile_sim_id.type = 'hidden';
				product_mobile_sim_id.name = 'products[0][product_id]';
				product_mobile_sim_id.value = response.mobile_sim.id;
				_that.form.appendChild(product_mobile_sim_id);

				const product_mobile_sim_activation_code = document.createElement('input');
				product_mobile_sim_activation_code.type = 'hidden';
				product_mobile_sim_activation_code.name = 'products[0][product_data][activation_code]';
				product_mobile_sim_activation_code.value = _that.form_activation_code.value;
				_that.form.appendChild(product_mobile_sim_activation_code);

				_that.form.setAttribute('action', url('/process/buy'));
				_that.form.setAttribute('method', 'POST');
				_that.form.submit();
			} else {
				window.location.href = url('/account/activate_sim', {'activation_code': _that.form_activation_code.value});
			}
		} else {
			_that.form_response_message.innerHTML = response.message;
			_that.form_response_message.classList.remove('hidden');

			_that.validateActivationCodeReset();
		}
	}

	validateActivationCodeReset() {
		console.log('PageActivate::validateActivationCodeReset()');
		let _that = this;

		if (_that.recaptcha !== null) {
			_that.recaptcha.reset();
		}
		_that.form_submit.disabled = false;
		_that.form_activation_code.readOnly = false;
		_that.form_spinner.classList.add('hidden');
	}

	doAjax() {
		console.log('PageActivate::doAjax()');
		let _that = this;

		return new Promise((resolve, reject) => {
			let form_url = _that.form.getAttribute('action');
			if (form_url === '') {
				form_url = url('/process_activate');
			}

			$.ajax({
				type: 'POST',
				url: form_url,
				data: $(`#${_that.form.id}`).serialize(),
				success: (response) => {
					resolve(response);
				},
				error: (err) => {
					reject(err);
				}
			});
		});
	}
}
